import React from 'react'
import PropTypes from 'prop-types'
import MessageController from '../../Interaction/controller/Message'
import MessageService from '../../Interaction/services/Message'

const withInteractionService = (WrappedComponent) => {
    function _withInteractionService(props = {}) {
        const MsgService = MessageService({
            botname: props.botname,
            Interactions: props.Interactions
        })

        const MsgController = MessageController({
            MessageService: MsgService
        })

        const sendMessage = async (input = '', options = {}) => {
            let response = {}
            try {
                response = await MsgController.sendMessage(input, options)
            } catch (error) {
                throw error
            }
            
            return response
        }

        return <WrappedComponent 
            {...props}
            sendMessage={sendMessage}
        />
        
    }

    const componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    _withInteractionService.displayName = `_withInteractionService(${componentName})`
    
    WrappedComponent.propTypes = {
        botname: PropTypes.string.isRequired,
        Interactions: PropTypes.shape({
            send: PropTypes.func
        }).isRequired,
        intents: PropTypes.shape({
            welcome: PropTypes.string
        })
    }

    _withInteractionService.propTypes = {
        sendMessage: PropTypes.func
    }

    return _withInteractionService
}

export default withInteractionService